// extracted by mini-css-extract-plugin
export default {"wrapper":"calculator_wrapper__a4Ema"};